import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable, Subject} from "rxjs";

export interface IfilterOptionReq {
  underlyingSymbol: string;
  chainType: string;
  strikePrice: string;
}

@Injectable({
  providedIn: 'root'
})
export class IrbOptionChainsService {

  optionChainSymbolSelectionsSource = new Subject<any>();
  optionChainSymbolSelections$: Observable<any> = this.optionChainSymbolSelectionsSource.asObservable();
  public createSecurityBySymbolMultilineValues: string;

  constructor(readonly http: HttpClient) {
  }

  getFilterOptions(filterOptions: IfilterOptionReq): Observable<any> {
    return this.http.post('/irebalone/rebalance-portfolios/filter-options', JSON.stringify(filterOptions), {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
      })
    });
  }

  addOptionChainSymbolSelections(optionsData: any) {
    this.optionChainSymbolSelectionsSource.next(optionsData);
  }
}
